'use strict';
var parent = require('../../es/instance/concat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/concat.js
// module id = 760
// module chunks = 13